/**
 * Cửa ra nhóm `/api/v1/m/audit/vet` (màn Sử dụng AI, module `audit`, ADR-0095) — port `nhat-ky-vet.repository.ts` của
 * web-portal native qua `goiAudit`. Cùng đường con, cùng tên trường snake_case (`module/VetController.java`).
 *
 * Không có `tenant_id` ở bất kỳ lời gọi nào (tenant lấy từ ngữ cảnh Gateway ký), không có API ghi: nhật ký chỉ thêm và
 * đọc. Không có chi phí vốn: audit-service không trả cột ấy cho tenant.
 */
import type {
  ChuoiVet,
  KetQuaLuong,
  TrangLuotGoi,
  TrangTrace,
  TruyVanLuong,
  TruyVanLuotGoi,
  TruyVanTrace,
  TuyChonLocAi,
} from '../../modules/nhat-ky-truy-vet/chung/nghiep-vu/types-vet';
import type { ThongKeAi, TruyVanThongKeAi } from '../../modules/nhat-ky-truy-vet/chung/nghiep-vu/types-thong-ke';
import { goiAudit, type GiaTriQuery } from './nktv';

/** Tham số có kiểu → bản ghi `goiAudit` nhận. Kiểu truy vấn chỉ mang chuỗi, số và boolean. */
const q = (thamSo: object): Record<string, GiaTriQuery> => thamSo as Record<string, GiaTriQuery>;

export const nktvSuDungAiRepository = {
  /**
   * `GET /vet/trace` — danh sách chuỗi xử lý, phân trang theo con trỏ keyset. `con_tro` chỉ truyền khi lấy trang TIẾP và
   * chỉ có nghĩa trong đúng bộ lọc đã sinh ra nó; nơi gọi để `con_tro` ra ngoài `queryKey`.
   */
  trace: (thamSo: TruyVanTrace): Promise<TrangTrace> => goiAudit<TrangTrace>('/vet/trace', { query: q(thamSo) }),

  /** `GET /vet/trace/{trace_id}` — các bước của một chuỗi, nguồn của waterfall. 404 khi chuỗi không có bước nào. */
  chuoi: (traceId: string): Promise<ChuoiVet> => goiAudit<ChuoiVet>(`/vet/trace/${encodeURIComponent(traceId)}`),

  /** `GET /vet/luot-goi` — từng lượt gọi mô hình, phân trang theo con trỏ. */
  luotGoi: (thamSo: TruyVanLuotGoi): Promise<TrangLuotGoi> =>
    goiAudit<TrangLuotGoi>('/vet/luot-goi', { query: q(thamSo) }),

  /** `GET /vet/bo-loc` — giá trị cho các ô lọc. Hai mốc BẮT BUỘC. */
  boLoc: (thamSo: { tu: string; den: string }): Promise<TuyChonLocAi> =>
    goiAudit<TuyChonLocAi>('/vet/bo-loc', { query: q(thamSo) }),

  /** `GET /vet/luong` — gom theo đối tượng nghiệp vụ. Một trang, server đã sắp theo token giảm dần. */
  luong: (thamSo: TruyVanLuong): Promise<KetQuaLuong> => goiAudit<KetQuaLuong>('/vet/luong', { query: q(thamSo) }),

  /** `GET /vet/thong-ke-ai` — token và chi phí theo thời gian, tách bảy loại. Hai mốc BẮT BUỘC. */
  thongKeAi: (thamSo: TruyVanThongKeAi): Promise<ThongKeAi> =>
    goiAudit<ThongKeAi>('/vet/thong-ke-ai', { query: q(thamSo) }),
};
